import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportSummarySalesPage } from './report-summary-sales.page';

const routes: Routes = [
  {
    path: '',
    component: ReportSummarySalesPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportSummarySalesPageRoutingModule {}
